import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getDealershipControlForUser = async (user) => {
  try {
    const groupId = user?.activeGroupId || user?.groupId || user?.id || user;
    const getDealershipControlFn = httpsCallable(functions, 'getDealershipsByGroupV2');
    const result = await getDealershipControlFn({
      groupId,
      requestedApp: 'group_web',
    });
    if (result.data.success === 'yes') {
      return { hasDealership: true, dealershipData: result.data.data };
    } else {
      return { hasDealership: false, dealershipData: null };
    }
  } catch (error) {
    console.error('Error obteniendo control de concesionario:', error);
    notifyPermissionDenied(error);
    return { hasDealership: false, dealershipData: null };
  }
};
